/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

import Field from '@salesforce/retail-react-app/app/components/field';
import useLoginFields from '@salesforce/retail-react-app/app/components/forms/useLoginFields';
import {Box, Button, Stack, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

const LoginFields = ({
  form,
  handleForgotPasswordClick,
  prefix = '',
  hideEmail = false,
  hidePassword = false,
}) => {
  const fields = useLoginFields({form, prefix});
  const styles = useMultiStyleConfig('FormAuth', {});

  return (
    <Stack spacing={4}>
      {!hideEmail && <Field {...fields.email} />}
      {!hidePassword && (
        <Stack spacing={4}>
          <Field {...fields.password} />
          {handleForgotPasswordClick && (
            <Box>
              <Button {...styles.buttonForgotPassword} variant="link" onClick={handleForgotPasswordClick}>
                <FormattedMessage
                  defaultMessage="Forgot your password?"
                  id="login_form.link.forgot_password"
                />
              </Button>
            </Box>
          )}
        </Stack>
      )}
    </Stack>
  );
};

LoginFields.propTypes = {
  handleForgotPasswordClick: PropTypes.func,

  /** Object returned from `useForm` */
  form: PropTypes.object.isRequired,

  /** Optional prefix for field names */
  prefix: PropTypes.string,

  /** Optional configurations */
  hideEmail: PropTypes.bool,
  hidePassword: PropTypes.bool,
};

export default LoginFields;
